import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppOnlinePaymentAdyenComponent } from './app-online-payment/app-online-payment-adyen/app-online-payment-adyen.component';
import { AppOnlinePaymentFailedComponent } from './app-online-payment/app-online-payment-failed/app-online-payment-failed.component';
import { AppOnlinePaymentSuccessComponent } from './app-online-payment/app-online-payment-success/app-online-payment-success.component';
import { HomeComponent } from './home/home.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';


const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "home",
    component: HomeComponent,
  },
  {
    path: "app-online-payment-adyen",
    component: AppOnlinePaymentAdyenComponent,
  },
  {
    path: "app-online-payment-success",
    component: AppOnlinePaymentSuccessComponent,
  },
  {
    path: "app-online-payment-failed",
    component: AppOnlinePaymentFailedComponent,
  },
  {
    path: "terms-condition",
    component: TermsConditionComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
